import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

const useVolume = () => {
  const [volumes, setVolumes] = useState([])

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/volume/all')
        .then((response) => {
          setVolumes(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    consultApi()
  }, [])

  return [volumes]
}

export default useVolume
